(() => {
  const findAll=(root,selector)=>[
    ...(root.matches?.(selector)?[root]:[]),
    ...root.querySelectorAll(selector)
  ];
  const cachedParts=new Set();
  function initialise(root=document) {
    findAll(root,'[data-al-configurator]').forEach(el=>{
      if(el.dataset.ready)return; el.dataset.ready='true';
      el.querySelectorAll('input[data-part][data-image]').forEach(input=>{
        const url=input.dataset.image;
        if(!url||cachedParts.has(url))return;
        cachedParts.add(url);
        const image=new Image();image.src=url;
      });
      const update=()=>{
        const picked={};
        for(const role of ['case','upper','lower','charm']) {
          const input=el.querySelector(`input[data-part="${role}"]:checked`);
          const image=el.querySelector(`img[data-layer="${role}"]`);
          const label=el.querySelector(`[data-selected="${role}"]`);
          if(!input)continue;
          picked[role]=input.value;
          if(label)label.textContent=input.value;
          if(image){image.hidden=!input.dataset.image; if(input.dataset.image){image.removeAttribute('srcset');image.src=input.dataset.image;image.alt=`${role==='case'?'ケース':role==='upper'?'上部リボン':role==='lower'?'下部リボン':'チャーム'}：${input.value}`;}}
          if(role==='case') {
            const stage=el.querySelector('.al-preview-stage');
            if(stage)for(const [property,value] of Object.entries({'upper-x':input.dataset.centerX,'lower-x':input.dataset.centerX,'upper-y':input.dataset.upperY,'lower-y':input.dataset.lowerY,'part-width':input.dataset.partWidth})) {
              if(value!==undefined&&Number.isFinite(Number(value)))stage.style.setProperty(`--${property}`,`${Number(value)}%`);
            }
          }
        }
        el.dataset.selection=JSON.stringify(picked);
      };
      el.addEventListener('change',update);update();
    });
    root.querySelectorAll('[data-al-calendar]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      const now=new Date();
      const local=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
      const [year,month]=local.split('-').map(Number);let current=new Date(Date.UTC(year,month-1,1));
      const closed=(el.dataset.closed||'').split(',').map(x=>x.trim()).filter(Boolean);
      const weekdays=['日','月','火','水','木','金','土'];
      const render=()=>{
        const parent=el.querySelector('[data-months]');parent.replaceChildren();
        for(let n=0;n<2;n++) {
          const date=new Date(Date.UTC(current.getUTCFullYear(),current.getUTCMonth()+n,1));
          const y=date.getUTCFullYear(),m=date.getUTCMonth();
          const wrap=document.createElement('section'),title=document.createElement('h3');
          title.className='al-month-title';title.textContent=`${y}年${m+1}月`;wrap.append(title);
          const grid=document.createElement('div');grid.className='al-month-grid';grid.setAttribute('aria-label',`${y}年${m+1}月`);
          weekdays.forEach(day=>{const item=document.createElement('span');item.className='al-weekday';item.textContent=day;grid.append(item)});
          for(let i=0;i<date.getUTCDay();i++){const empty=document.createElement('span');empty.setAttribute('aria-hidden','true');grid.append(empty)}
          const length=new Date(Date.UTC(y,m+1,0)).getUTCDate();
          for(let d=1;d<=length;d++){
            const day=document.createElement('span'),iso=`${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`,week=new Date(Date.UTC(y,m,d)).getUTCDay();
            day.className='al-day'+(week===0?' sun':week===6?' sat':'')+(iso===local?' today':'')+(closed.includes(iso)?' closed':'');day.textContent=String(d);
            day.setAttribute('aria-label',`${m+1}月${d}日${iso===local?' 今日':''}${closed.includes(iso)?' 休業日':''}`);grid.append(day);
          }
          wrap.append(grid);parent.append(wrap);
        }
      };
      el.querySelector('[data-calendar-prev]')?.addEventListener('click',()=>{current=new Date(Date.UTC(current.getUTCFullYear(),current.getUTCMonth()-1,1));render()});
      el.querySelector('[data-calendar-next]')?.addEventListener('click',()=>{current=new Date(Date.UTC(current.getUTCFullYear(),current.getUTCMonth()+1,1));render()});render();
    });
    root.querySelectorAll('[data-al-slideshow]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      const slides=Array.from(el.querySelectorAll('[data-slide]'));
      el.querySelectorAll('[data-slide-index]').forEach(button=>button.addEventListener('click',()=>{
        const active=Number(button.dataset.slideIndex);slides.forEach((s,i)=>s.hidden=i!==active);
        el.querySelectorAll('[data-slide-index]').forEach((b,i)=>b.setAttribute('aria-current',String(i===active)));
      }));
    });
    root.querySelectorAll('form[data-sales-paused="true"]').forEach(form=>{
      if(form.dataset.pauseGuardReady)return;form.dataset.pauseGuardReady='true';
      form.addEventListener('submit',event=>event.preventDefault());
    });
    root.querySelectorAll('[data-variant-select]').forEach(select=>{
      if(select.dataset.ready)return;select.dataset.ready='true';
      const update=()=>{const o=select.selectedOptions[0],form=select.closest('form');if(!o||!form)return;const b=form.querySelector('[data-buy]'),price=form.querySelector('[data-variant-price]'),paused=form.dataset.salesPaused==='true';if(b){b.disabled=paused||o.dataset.available==='false';b.textContent=paused?'準備中':b.disabled?'売り切れ':'カートに追加'}if(price)price.textContent=o.dataset.price||''};select.addEventListener('change',update);update();
    });
    root.querySelectorAll('[data-show-selection]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',()=>{const config=document.querySelector('[data-al-configurator]'),dialog=document.querySelector('[data-selection-dialog]');if(!config||!dialog)return;const values=JSON.parse(config.dataset.selection||'{}');for(const key of ['case','upper','lower','charm']){const target=dialog.querySelector(`[data-summary="${key}"]`);if(target)target.textContent=values[key]||'なし'}dialog.showModal()});
    });
    root.querySelectorAll('[data-close-dialog]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>button.closest('dialog').close())});
  }
  document.addEventListener('DOMContentLoaded',()=>initialise());
  document.addEventListener('shopify:section:load',e=>initialise(e.target));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.al-menu[open]').forEach(el=>el.open=false)});
})();
